<template>
  <div class="modal-background">
    <div class="modal-container">
      <div class="modal-title">
        <div class="is-18b">신규가입 결제 전 안내</div>
        <svg
          class="close-icon cursor"
          @click="$emit('close')"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M19 5.5L5 19.5M19 19.5L5 5.5" stroke="#646464" stroke-width="2" stroke-linecap="round" />
        </svg>
      </div>

      <div class="modal-content">
        <div class="is-16m">
          미팅 가입 이력이 있는 경우, 연회비 할인 적용이 가능합니다.
          <br />
          원활한 할인 적용을 위해, 연회비 결제 전 회원 검색 및 유선 연락 절차를안내드립니다.
          <br />
          <br />
          <b>1. 회원 검색:</b>
          <br />
          결제 진행 전, 소속되어 있는 회사가 이전 회원가입 이력이 있는지<br />
          회원사검색(<span class="color" @click="onClickUrl">{{ url }}</span
          >)<br />
          에서 확인해 주시기 바랍니다.<br />
          <br />
          <b>2. 유선 연락:</b>
          <br />
          이전 회원 가입 이력 확인된 경우,<br />
          할인가 적용을 위해 담당자에게 유선으로 연락하여 주세요.<br />
          <br />
          Tel 02-2268-2504<br />
          <br />
          *기타 문의사항은 유선으로 문의하여 주시기 바랍니다.
          <br />
          <br />
        </div>
      </div>
      <div class="btn-wrap">
        <div class="cancel-btn is-16b" @click="$emit('close')">닫기</div>
        <div class="link-btn is-16b" @click="onClickLinkBtn">가입하기</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MembershipPaymentInfoModal',
  props: {
    memberType: {
      type: String,
      default: 'MMT01'
    },
    contact: {
      type: String,
      default: ''
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden'
  },
  unmounted() {
    document.body.style.overflow = 'auto'
  },
  computed: {
    url() {
      let menuIdx = 0
      switch (this.memberType) {
        case 'MMT02':
          menuIdx = 1
          break
        case 'MMT03':
          menuIdx = 2
          break
        case 'MMT04':
          menuIdx = 3
          break
      }
      return `https://insabank.com/membership-business?menu=${menuIdx}&subMenu=0&company=1`
    }
  },
  methods: {
    onClickUrl() {
      window.open(this.url, '_blank')
    },
    onClickLinkBtn() {
      this.$emit('close')
      this.$router.push(`/membership-business/payment?type=${this.memberType}&isNew=1`)
    }
  }
}
</script>

<style scoped lang="scss">
.modal-background {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #0f0f0f50;
  z-index: 100;
}

.modal-container {
  width: 700px;
  max-height: calc(100% - 64px);
  padding: 24px;
  background: #ffffff;

  .modal-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #151515;
  }

  .modal-content {
    display: flex;
    flex-direction: column;

    .color {
      text-decoration: underline;
      cursor: pointer;
      color: #0058aa;
    }
  }

  .btn-wrap {
    margin-top: 24px;
    display: flex;
    align-items: center;
    gap: 16px;

    .cancel-btn {
      width: 50%;
      padding: 8px 0;
      border-radius: 4px;
      text-align: center;
      background: #f5f5f5;
      color: #646464;
      cursor: pointer;
    }

    .link-btn {
      width: 50%;
      padding: 8px 0;
      border-radius: 4px;
      text-align: center;
      background: #0058aa;
      color: white;
      cursor: pointer;
    }
  }
}
</style>
